// extracted by mini-css-extract-plugin
module.exports = {"header":"_2kxMN","title":"_1X154","cancel":"_2szPx"};